import React, { useCallback, useContext, useState } from "react";
import { USERTYPES, REPORT_DONE_STATUS } from "../../../../constants/Constants";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import userContext from "../../../../context/users/UserContext";
import '../../styles/styles.css';
import DropdownSection from "./DropdownSection";
import TemplateCategory from "./TemplateCategory";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import S10Icon from "../../../../components/SVGComponents/S10Icon";
import ModalMain from "../../../../components/Modal/ModalMain";
import ModalHeader from "../../../../components/Modal/ModalHeader";
import ModalFooter from "../../../../components/Modal/ModalFooter";
import { t } from "i18next";
import themeContext from "../../../../context/theme/ThemeContext";
import { RobotIcon } from "@fluentui/react-icons-mdl2";

const RadioDropdownSection = () => {

    const { roles, username, authenticated, loadByUsername, userId } = useContext(userContext);
    const { getThemeColor } = useContext(themeContext);
    const { s10User, s10Url, setShowFormatterPopupClipped, reportDoneStatusState, usgAgentEnabled, reportingDoctorName, isExternal, isWordFilePath } = useContext(studyReportContext);
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const togglePopup = useCallback(() => {
        setIsPopupOpen(prevState => !prevState);
    }, []);

    let DefaultButtonList = [
        {
            title: "Close",
            onclick: togglePopup,
        },
    ];

    const modalDetails = {
        header: (
            <ModalHeader
                updatedModal={true}
                heading="S10.ai"
                handleCancel={togglePopup}
            />
        ),
        body: <div className="global-modal-body" style={{ color: getThemeColor("primary-color"), padding:"0px" }}>
            <iframe
                id="s10Iframe"
                src={s10Url}
                style={{
                    //width: '100%',
                    height: '525px',
                    border: 'none',
                    background: 'transparent',
                }}
                allow='web-share;clipboard-write;autoplay;camera;microphone;display-capture'
            />
        </div>,
        footer: <ModalFooter PrimaryButtonList={[]} DefaultButtonList={DefaultButtonList} />,
        width: "380px"
    };

    return (
        <>
            <div className="ms-Grid " dir="ltr" style={{ margin: "0px", display: "flex", justifyContent: "flex-start", alignItems: "center", width: "100%" }}>

                {(usgAgentEnabled && !isExternal && !isWordFilePath && reportDoneStatusState < 2 && reportingDoctorName !== null && reportingDoctorName == username) ? 
                <span style={{
                    display: 'flex', alignItems: 'center', gap: '6px', minWidth: '142px',
                    cursor:
                        reportDoneStatusState === REPORT_DONE_STATUS.REPORTED
                            ? "not-allowed"
                            : "pointer",
                    paddingBottom: '6px'
                }}

                    onClick={(e) => {
                        if (reportDoneStatusState === REPORT_DONE_STATUS.REPORTED) {
                            e.stopPropagation();
                            e.preventDefault();
                            return;
                        }
                        setShowFormatterPopupClipped(true)
                    }}
                >
                    <RobotIcon style={{ fontSize: 18, color: "#0066FF" }} />
                    {t("clipped-key-images.manage-key-image")}
                </span> : null}

             {<TemplateCategory />}
                {/* <DropdownSection /> */}
                {s10User && <div style={{ marginLeft: "auto" }}>
                    <span style={{ cursor: "pointer", padding: "7px 12px", borderRadius: "8px", backgroundColor: "#003a5f", display: "flex"}} 
                        onClick={togglePopup}>
                        <S10Icon />
                    </span>
                </div>}
            </div>

            {isPopupOpen && (<ModalMain
                updatedModal={true}
                modalDetails={modalDetails}
                showModal={true}
            />
            )}

        </>
    )
};

export default RadioDropdownSection;